import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=e2fd7874&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2fd7874')) {
      api.createRecord('e2fd7874', component.options)
    } else {
      api.reload('e2fd7874', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=e2fd7874&", function () {
      api.rerender('e2fd7874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22iLSi91dX5R6/JS/comp/cancellationPolicy.vue"
export default component.exports